module.exports = __webpack_public_path__ + "img/admans_logo.64ddae20.png";